import { Component, OnInit, Input } from '@angular/core';
import { removeAnItem, removeAnItens, mapArrayByProperties, filterSystemFields } from '@shared/utils/util';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SystemFieldService } from '@app/services/system-field/system-field.service';
import { LoaderService } from '../loader/loader.service';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-edit-form-relation',
  templateUrl: './edit-form-relation.component.html',
  styleUrls: ['./edit-form-relation.component.scss']
})
export class EditFormRelationComponent implements OnInit {

  @Input() dateFields;
  @Input() dateField;
  @Input() editorMode;

  public availableFieldsForRelation = [];
  public relatedFields = [];
  public relatedFieldsBefore = [];
  public selectedField = null;
  public removable = true;
  public fields: Observable<any[]>;

  public formulario: FormGroup;

  constructor(private systemFieldService: SystemFieldService, private loaderService: LoaderService, private formBuilder: FormBuilder) {}

  ngOnInit(): void {

    this.formulario = this.formBuilder.group({
      relation_field: null,
    });

    if (this.editorMode) {
      this.removable = false;
      this.dateFields = JSON.parse(JSON.stringify(this.dateFields));
      this.relatedFields = this.dateField.field_relation ?? [];
    } else {
      this.dateFields = JSON.parse(JSON.stringify(this.dateFields));
      this.relatedFields = this.dateField.field_relation;
      const filter = this.dateFields.fields.filter(value => {
        if (value.predefined_source_options === 1) {
          return value;
        }
      });
      this.dateFields.fields = filter;
      this.availableFieldsForRelation = removeAnItem(this.dateFields.fields, 'field_id', this.dateField.field_id);
      this.availableFieldsForRelation = removeAnItens(this.availableFieldsForRelation, this.relatedFields, 'field_id');
      this.relatedFieldsBefore = JSON.parse(JSON.stringify(this.relatedFields));
    }
    this.fields = of(this.availableFieldsForRelation);
    this.initAutoCompleteFields();
    this.subscribeChanged();
  }

  public displayFn(field: any): string {
    return field && field.label ? field.label : '';
  }

  public initAutoCompleteFields(): boolean {    
    this.fields = this.formulario.get('relation_field').valueChanges
      .pipe(
        startWith(''),
        map(option => option ? filterSystemFields({value: option, systemFields: this.availableFieldsForRelation} ) : this.availableFieldsForRelation.slice())
      );
    return true;
  }

  public subscribeChanged() {
    this.formulario.get('relation_field').valueChanges.subscribe((value) => {
      this.selectedField = value;
    })
  }

  public relating() {
    if (this.selectedField !== null) {
      this.setCurrentFieldIfNeeded();
      if (typeof this.selectedField.wasRemoved === 'undefined') {
        this.systemFieldService.read(this.selectedField.field_id).subscribe(
          success => {
            if (success.success) {
              if (success.data.field_relation.length > 0) {
                this.setChange(success.data.field_relation);
                this.relatedFields = [...this.relatedFields, ...success.data.field_relation];
                this.relatedFields = mapArrayByProperties(this.relatedFields, ['field_id', 'label', 'relation_id', 'new']);
                this.availableFieldsForRelation = removeAnItens(this.availableFieldsForRelation, this.relatedFields, 'field_id');
                delete this.dateField.relation_id;
              } else {
                this.relatedFields.push(this.selectedField);
              }
              this.dateField.field_relation = this.relatedFields;
              this.availableFieldsForRelation = removeAnItens(this.availableFieldsForRelation, this.relatedFields, 'field_id');
              this.selectedField = null;
            }
          },
          error => {
            this.loaderService.setChangesLoaderState(false,
              error.body,
              '',
              'error',
              error.title,
              100000);
          }
        );
      } else {
        this.relatedFields.push(this.selectedField);
        this.dateField.field_relation = this.relatedFields;
        this.availableFieldsForRelation = removeAnItens(this.availableFieldsForRelation, this.relatedFields, 'field_id');
        this.selectedField = null;
      }

    }
  }

  public remove(relation): void {
    const index = this.relatedFields.indexOf(relation);

    if (index >= 0) {
      this.relatedFields.slice(index);
      this.dateField.field_relation.splice(index, 1);
      this.verification(this.relatedFields);
      if (relation.field_id !== this.dateField.field_id) {
        relation.wasRemoved = 1;
        this.availableFieldsForRelation.unshift(relation);
      }
    }
  }

  private setChange(date) {
    for (const key in date) {
      if (date.hasOwnProperty(key)) {
        const element = date[key];
        element.new = 1;
      }
    }
  }

  private verification(date) {
    const obj = date.find(o => o.new === 1);
    if (typeof obj === 'undefined' && this.relatedFieldsBefore.length > 0) {
      // tslint:disable-next-line: forin
      for (const keyCurrent in date) {
        for (const keyBefore in this.relatedFieldsBefore) {
          if (date[keyCurrent].field_id === this.relatedFieldsBefore[keyBefore].field_id) {
            date[keyCurrent] = this.relatedFieldsBefore[keyBefore];
          }
        }
      }
      this.dateField.relation_id = this.relatedFieldsBefore[0].relation_id;
      this.isOnlyFieldItself();
    }
  }

  private isOnlyFieldItself() {
    if (this.relatedFields.length === 1) {
      this.relatedFields = [];
    }

    if (this.dateField.field_relation.length === 1) {
      this.dateField.field_relation = [];
    }
  }

  private setCurrentFieldIfNeeded() {
    const obj = this.relatedFields.find(o => o.field_id === this.dateField.field_id);
    if (typeof obj === 'undefined' && this.relatedFieldsBefore.length > 0) {
      for (const key in this.relatedFieldsBefore) {
        if (this.relatedFieldsBefore.hasOwnProperty(key)) {
          const element = this.relatedFieldsBefore[key];
          if (element.field_id === this.dateField.field_id) {
            this.relatedFields.push(element);
          }
        }
      }
    }
  }

}
